import { smartLinksSchema } from '../smartLinksPlugin';

export function retrieveEntityTypeByRegex(regexString: string) {
  const schemaItem = smartLinksSchema.find(({ urlRegexString }) => urlRegexString === regexString);
  return schemaItem.entityType;
}
